import React from 'react'
import { Helmet } from 'react-helmet-async'
import ServicePageTemplate, { ServicePageConfig } from '../../components/templates/ServicePageTemplate'

const moutaiConfig: ServicePageConfig = {
  title: 'Moutai - Bespoke Shopping | FGA Prestige',
  description: 'Providing access to exclusive Moutai collections and limited editions through our bespoke shopping service.',
  slug: 'bespoke-shopping/moutai',
  heroImage: '/Bespoke Shopping/Retail Partners/MOUTAI/hero.png',
  serviceName: 'MOUTAI',
  whySectionA: {
    title: 'Gateway to China\'s Most Coveted Spirit',
    content: 'When it comes to the world of luxury spirits, few names command the same reverence as Feitian Moutai. And when it comes to sourcing authentic bottles of this legendary baijiu, there\'s something to be said for working with people who truly understand both the product and the market. That\'s exactly what you get with our family business – over two decades of expertise in wine and spirits wholesale, and a deep appreciation for what makes Moutai so extraordinary.',
    image: '/Bespoke Shopping/Retail Partners/MOUTAI/body/1.png',
    imageAlt: 'Moutai Expert Authentication'
  },
  whySectionC: {
    title: 'Liquid Gold',
    content: 'Here\'s where our two decades of experience really counts. The Moutai market has unfortunately attracted sophisticated counterfeiters who use methods like drilling tiny 0.2mm holes in bottles to replace authentic liquid with inferior substitutes . These fakes are so well-executed that even experienced distributors can be fooled.',
    image: '/Bespoke Shopping/Retail Partners/MOUTAI/body/2.png',
    imageAlt: 'Moutai Expert Authentication'
  },
  whySectionB: {
    title: 'Legacy of Chinese Luxury',
    benefits: [
      {
        title: '',
        description: 'This is exactly why working with established, trusted distributors matters so much. Our family business has spent over 20 years building relationships throughout the wine and spirits industry, developing the expertise to authenticate products and ensure proper provenance. When you\'re dealing with bottles that can cost thousands of dollars, that peace of mind is invaluable.'
      }
    ],
    image: '/Bespoke Shopping/Retail Partners/MOUTAI/body/3.png',
    imageAlt: 'Premium Moutai collection'
  },
  masterpieceBackgroundImage: '/Bespoke Shopping/Retail Partners/MOUTAI/CTA_Banner/banner.png'
}

const MoutaiPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Moutai - Bespoke Shopping | FGA Prestige</title>
        <meta name="description" content="Providing access to exclusive Moutai collections and limited editions through our bespoke shopping service." />
        <meta property="og:title" content="Moutai - Bespoke Shopping | FGA Prestige" />
        <meta property="og:description" content="Providing access to exclusive Moutai collections and limited editions through our bespoke shopping service." />
        <meta property="og:url" content="https://fgaprestige.com/bespoke-shopping/moutai" />
        <meta property="og:image" content="/Bespoke Shopping/Retail Partners/MOUTAI/hero.png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:alt" content="FGA Prestige Moutai Collection" />
      </Helmet>
      
      <ServicePageTemplate config={moutaiConfig} />
    </>
  )
}

export default MoutaiPage